import React, { useRef, useEffect } from "react";

import PropTypes from "prop-types";

const propTypes = {
  speech: PropTypes.object,
};

const ReadAloudAudio = ({ speech }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!speech) return;
    let animationId;

    audioRef.current.onended = () => {
      speech.swapToNextAudioFile();
    };

    const updateTime = () => {
      if (audioRef?.current && !audioRef.current.paused) {
        speech.setCurrentTime(audioRef.current.currentTime * 1000);
      }
      // requestAnimationFrame is used here to improve performance.
      animationId = requestAnimationFrame(updateTime);
    };

    updateTime();

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [speech?.currentTextChunkIndex]);

  useEffect(() => {
    const audio = audioRef.current;

    if (speech.shouldSyncTimeAfterRateChange) {
      speech.pauseAudio();
      audio.currentTime = speech.currentTime ? speech.currentTime / 1000 : 0;

      speech.setShouldSyncTimeAfterRateChange(false);
    }

    speech.playAudio();

    return () => {
      // When the component unmounts, save the currentTime to resume at the same point in time.
      speech.setCurrentTime(audio.currentTime * 1000);
    };
  }, [speech.shouldSyncTimeAfterRateChange]);

  useEffect(() => {
    if (!audioRef || !audioRef.current) return;

    const audio = audioRef.current;

    // Check if the current audio player status reflects the expected status from isPlaying.
    // If it does not, play or pause the audio as appropriate.
    if (speech.isPlaying && audio.paused) {
      audio.play();
    } else if (!speech.isPlaying && !audio.paused) {
      audio.pause();
    }
  });

  return (
    <div style={{ display: "none" }}>
      <audio
        controls
        src={speech?.vocalFiles[speech.currentTextChunkIndex]}
        ref={audioRef}
        id="read-aloud-audio"
      >
        Your browser does not support the <code>audio</code> element for read
        aloud mode.
      </audio>
    </div>
  );
};

ReadAloudAudio.propTypes = propTypes;
export default ReadAloudAudio;
